<template>
  <div class="dashboard-main">
    <div v-if="userInfo.dept_id === 100">
      <div class="dashboard-app-container">
        <div class="header">
          <div class="header-title" @click="refresh">
            <el-tooltip :content="tooltipCenter" placement="top">
              <div>实时概况</div>
            </el-tooltip>
            <p>更新时间：{{ updataTiem }}</p>
          </div>
        </div>
        <div class="home-box">
          <div class="home-box-row">
            <div
              class="box-col"
              v-for="(amountItem, amountIndex) in amount"
              :key="amountIndex"
            >
              <div
                class="box-col-item"
                v-for="(item, index) in amountItem.list"
                :key="index"
              >
                <div class="overview-data-item">
                  <div class="data-item-title">{{ item.title }}</div>
                  <div class="data-item-amount">
                    <span class="amount-today">
                      <count-to
                        :start-val="0"
                        :end-val="item.toDay"
                        :duration="2000"
                      />
                    </span>
                    <i
                      class="amount-icon el-icon-bottom"
                      v-if="item.state === 2"
                    ></i>
                    <i
                      class="amount-icon el-icon-top"
                      v-if="item.state === 1"
                    ></i>
                  </div>
                  <div class="data-item-amount-yesterday">
                    昨日：
                    <span>{{ item.yesterday }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="census">
          <div class="header">
            <div class="header-title" @click="refresh">
              <el-tooltip :content="tooltipCenter" placement="top">
                <div>近三十天概况</div>
              </el-tooltip>
              <p>更新时间：{{ updataTiem }}</p>
            </div>
          </div>
          <lineChart />
        </div>
      </div>
    </div>
    <div v-else class="fenxiao">
      <div>印象普陀会员分销结算系统</div>
    </div>
  </div>
</template>
<script>
// 折线图
// import anim from "../components/anim/index.vue";
import lineChart from "../components/line-chart.vue";
import * as getData from "@/api/statistical-figure/index.js";
import { _setSessionStore, _getSessionStore } from "@/utils/storage";
import CountTo from "vue-count-to";
export default {
  computed: {},
  components: {
    CountTo,
    // anim,
    lineChart
  },
  data() {
    return {
      userInfo: {},
      tooltipCenter: "点击刷新数据",
      updataTiem: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      asideWidth: "92px",
      amount: [
        {
          list: [
            {
              title: "今日订单(元)",
              toDay: 11678.24,
              state: 2, // 1 涨 2 降
              yesterday: 45678.52
            },
            {
              title: "今日订单(笔)",
              toDay: 834423,
              state: 2, // 1 涨 2 降
              yesterday: 1453101
            },
            {
              title: "今日退单",
              toDay: 54126,
              state: 2, // 1 涨 2 降
              yesterday: 332521
            }
          ]
        },
        {
          list: [
            {
              title: "分销人员(位)",
              toDay: 75.54,
              state: 1, // 1 涨 2 降
              yesterday: 60.44
            },
            {
              title: "待推送订单",
              toDay: 1.54,
              state: 2, // 1 涨 2 降
              yesterday: 1.85
            },
            {
              title: "待审核提现",
              toDay: 640,
              state: 2, // 1 涨 2 降
              yesterday: 985
            },
            {
              title: "新增会员数",
              toDay: 547,
              state: 1, // 1 涨 2 降
              yesterday: 324
            }
          ]
        }
      ],
      avatar:
        "https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png",
      currentDate: new Date(),
      activeName: "second",
      option: {
        column: [
          {
            label: "姓名",
            prop: "name",
            rules: [
              {
                required: true,
                message: "请输入姓名",
                trigger: "blur"
              }
            ]
          },
          {
            label: "性别",
            prop: "sex",
            rules: [
              {
                required: true,
                message: "请输入性别",
                trigger: "blur"
              }
            ]
          }
        ]
      }
    };
  },
  mounted() {
    this.getData();
    this.userInfo = _getSessionStore("userInfo", "JSONStr");
    console.log(this.userInfo, "--------------------");
  },
  methods: {
    refresh() {
      this.getData();
      this.updataTiem = new Date().Format("yyyy-MM-dd hh:mm:ss");
    },
    getData() {
      getData.getCensusAll.r().then(res => {
        this.amount = [
          {
            list: [
              { ...res.order_number },
              { ...res.order_money },
              { ...res.order_refund },
              { ...res.refund_money }
            ]
          },
          {
            list: [
              { ...res.member },
              { ...res.share_member },
              { ...res.tobe_push },
              { ...res.tobe_reviewed }
            ]
          }
        ];
      });
    },
    handleClick(tab, event) {}
  }
};
</script>

<style lang="scss" scoped>
.fenxiao {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  // background-color: #0ff;
  font-size: 40px;
}
.census {
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;
  .header {
    display: flex;
    .header-title {
      font-size: 16px;
      font-weight: 900;
      color: #323233;
      display: inline-flex;
      align-items: center;
    }
    p {
      display: inline-block;
      font-size: 14px;
      color: #969799;
      margin-left: 7px;
      font-weight: 400;
    }
  }
}
.pie-wrap .line-wrap {
  width: 100%;
  height: 400px;
}
.dashboard-main {
  /*margin-top: 50px;*/
  /*height: calc(100vh - 50px);*/
  /*padding: 20px 20px 0;*/
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  margin: -10px;
  background-color: #f7f8fa;
}

.dashboard-aside {
  /*width: 240px;*/
  text-align: left;
  .aside-list {
    margin-bottom: 20px;
    .header {
      display: -ms-flexbox;
      display: flex;
      background-color: #fff;
      -ms-flex-align: center;
      align-items: center;
      padding: 20px 20px 15px;
      .title {
        font-size: 14px;
        color: #323233;
        font-weight: 700;
        margin-right: 10px;
      }
      .link {
        font-size: 12px;
      }
    }
    .list {
      background-color: #fff;
      padding: 0 20px 20px;
      color: #323233;
      li {
        font-size: 12px;
        line-height: 24px;
        height: 24px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        word-break: break-all;
      }
      .red {
        a {
          color: #d40000;
        }
        a:focus {
        }
        a:hover {
        }
      }
    }
  }
  .user-card {
    text-align: center;
  }
}
.dashboard-app-container {
  background: #fff;
  padding: 20px;
  .header {
    display: flex;
    justify-content: space-between;
    padding-left: 5px;
    margin-bottom: 20px;

    .header-title {
      font-size: 16px;
      font-weight: 900;
      color: #323233;
      display: inline-flex;
      align-items: center;

      p {
        display: inline-block;
        font-size: 14px;
        color: #969799;
        margin-left: 7px;
        font-weight: 400;
      }
    }
  }
  .home-box {
    padding: 0 20px;
    .home-box-row {
      display: flex;
      align-items: start;
      padding: 0 20px;
      justify-content: flex-start;
      box-sizing: border-box;

      .box-col {
        width: 50%;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;

        &:first-child {
          padding-right: 56px;
          border-right: 1px solid #efefef;
        }

        &:nth-child(2) {
          padding-left: 56px;
          border-right: 0;
        }

        .box-col-item {
          width: 50%;
          box-sizing: border-box;
          display: block;

          &:nth-child(3),
          &:nth-child(4) {
            margin-top: 30px;
          }
        }
      }

      .overview-data-item {
        color: #323233;
        font-size: 12px;
        text-align: left;
        height: 85px;

        .data-item-title {
          font-size: 14px;
          line-height: 14px;
          color: #969799;
        }

        .data-item-amount {
          position: relative;
          cursor: pointer;
          display: inline-block;
          margin: 15px 0 13px;
          color: #333;
          font-size: 16px;
          font-weight: bolder;

          &:hover {
            color: #155bd4;
          }

          .amount-today {
            font-size: 28px;
          }

          .amount-icon {
            display: inline-block;
            margin-left: 4px;
            vertical-align: top;
            margin-top: 8px;
            font-size: 18px;
          }

          .el-icon-bottom {
            color: #66be74;
          }

          .el-icon-top {
            color: #df4545;
          }
        }

        .data-item-amount-yesterday {
          color: #666;
          font-size: 14px;
          line-height: 14px;
        }
      }
    }
  }
}

.main-widget-box {
  text-align: left;
  .header {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: justify;
    justify-content: space-between;
    margin-bottom: 15px;
    .title {
      font-size: 14px;
      font-weight: 800;
      color: #323233;
      display: -ms-inline-flexbox;
      display: inline-flex;
      -ms-flex-align: center;
      align-items: center;
      border-left: 4px solid #3296fa;
      padding-left: 9px;
    }
    .action {
      font-size: 14px;
    }
  }
  .ump {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: justify;
    justify-content: space-between;
    .item {
      -ms-flex-preferred-size: calc(25% - 10px);
      flex-basis: calc(25% - 10px);
      box-sizing: border-box;
      text-align: center;
      border-radius: 4px;
      padding: 30px 0;
      opacity: 0.85;
      .title {
        color: #fff;
        font-size: 20px;
      }
      .desc {
        color: #fff;
        font-size: 14px;
        margin-top: 15px;
      }
    }
    .item:first-child {
      background-color: #22a266;
    }
    .item:nth-child(2) {
      background-color: #0177d4;
    }
    .item:nth-child(3) {
      background-color: #4c54bc;
    }
    .item:nth-child(4) {
      background-color: #c53d1c;
    }
  }
  .setting-user-avatar {
    width: 72px;
    height: 72px;
    border-radius: 50%;
  }
}
</style>
